import { useSyncExternalStore } from 'react';

/** Phone-sized screens (below Tailwind's `md`): sidebar as a drawer, panels full screen. */
const QUERY = '(max-width: 767px)';

const subscribe = (onChange: () => void) => {
  const mq = window.matchMedia(QUERY);
  mq.addEventListener('change', onChange);
  return () => mq.removeEventListener('change', onChange);
};

export const isMobile = () => window.matchMedia(QUERY).matches;

export function useIsMobile(): boolean {
  return useSyncExternalStore(subscribe, isMobile, () => false);
}
